import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Bookmark14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 0.25H11.5C12.1808 0.25 12.75 0.819166 12.75 1.5V12.5C12.75 13.5738 12 14 10.8953 13.5738L7.02 11.2583L3.14687 13.5725C2 14 1.25001 13.5738 1.25 12.4983L1.25001 12.4956L1.25 12.5V12.4983V1.5C1.25 0.819167 1.81917 0.25 2.5 0.25ZM2.75 1.75V12.0623L6.37014 9.89926C6.76089 9.65881 7.27911 9.65881 7.66986 9.89926L11.25 12.0384V1.75H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Bookmark14.displayName = 'Bookmark14';
export default Bookmark14;
